var map = {
	"./_prn.svg": 1755,
	"./csv.svg": 1756,
	"./empty.svg": 1757,
	"./file.svg": 1758,
	"./image.svg": 1759,
	"./pdf.svg": 1760,
	"./txt.svg": 1761,
	"./video.svg": 1762,
	"./xlsx.svg": 1763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1754;